import Server from "../server";
import View from "../framework/view";
import {Order} from "../bo/order";
import template from "../../pugc/cards";
import {CardView} from "./card";
import jQuery from "jquery";
import {Card, designersCardToEnd, orderToCards} from "../misc/cards";

const classname = "cards-view";

const server = Server.instance();

export class CardsView extends View {

    private ids: string[];

    private orders?: Order[];

    private cards?: Card[];

    private card?: Card;

    private cardView = new CardView();

    constructor(ids: string[]) {
        super(classname);
        this.ids = ids;
        this.init();
    }

    async init() {
        if (this.ids.length > 0) {
            this.orders = await server.getOrdersById(this.ids);

            const cards : Card[][] = [];
            for (const order of this.orders) {
                const cs = orderToCards(order);
                cards.push(cs);
            }

            this.cards = cards.flat().sort(designersCardToEnd);

            if (this.cards.length > 0) {
                this.selectCard(this.cards[0]);
            } else {
                this.update();
            }
        } else {
            const card = {
                text: "",
                designers_card: false
            };
            this.cards = [];
            this.selectCard(card);
        }
    }

    selectCard(card: Card | number) {
        if (! this.cards) {
            return;
        }

        if (typeof card === "number") {
            card = this.cards[card];
        }

        if (this.card === card) {
            return;
        }
        this.cardView.setCard(card);
        this.card = card;
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const idx = this.cards && this.card && this.cards.indexOf(this.card);
        const next = idx != undefined && this.cards && idx < this.cards.length - 1 ? this.cards[idx+1] : undefined;
        const nextIdx = next && idx != undefined ? idx + 1 : undefined;

        const data = {
            cards: this.cards,
            card: this.card,
            cardView: this.cardView,
            next: next,
            nextIdx: nextIdx,
        };

        const out = this.pug(template, data)

        return out;
    }

}

View.on(
    "." + classname,
    "click",
    "button.card",
    function(that: CardsView, event, elt) {
        event.preventDefault();
        const idx = +jQuery(elt).data("idx");
        that.selectCard(idx);
    });

